import React, { PureComponent } from 'react';
import PropType from 'prop-types';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import amplitude from 'amplitude-js/amplitude';
import { PAGE_VISIT_ACCOUNT_DELETION, ACCOUNT_DELETION_REQUEST_SUCCESS, ACCOUNT_DELETION_REQUEST_ERROR } from '../../constants/amplitudeEvents';
import ErrorMessage from '../../components/Errors/ErrorMessage';
import Loading from '../../components/Loading/Loading';
import getUrlParameters from '../../utils/getUrlParameters';
import apiService from '../../utils/api/apiService';

export class AccountDeletionPage extends PureComponent {
  static propTypes = {
    location: PropType.object.isRequired,
    t: PropType.func.isRequired,
  }

  static defaultProps = {
    location: null,
    t: (str) => str,
  }

  state = {
    deleteToken: getUrlParameters(this.props.location.search).dt || getUrlParameters(this.props.location.search).t,
    deleteRequestSent: false,
    deleteRequestError: false,
    loading: false,
  }

  componentDidMount() {
    amplitude.getInstance().logEvent(PAGE_VISIT_ACCOUNT_DELETION);
  }

  deleteAccount = () => {
    this.setState(() => ({ loading: true }));
    let params = { dt: this.state.deleteToken };
    return apiService.get('account/delete', params)
      .then(() => {
        amplitude.getInstance().logEvent(ACCOUNT_DELETION_REQUEST_SUCCESS);
        this.setState(() => ({ deleteRequestSent: true, loading: false }));
      })
      .catch((e) => {
        amplitude.getInstance().logEvent(ACCOUNT_DELETION_REQUEST_ERROR);
        this.setState(() => ({ deleteRequestError: true, loading: false }));
      });
  }

  render() {
    const {
      deleteToken,
      deleteRequestSent,
      deleteRequestError,
      loading,
    } = this.state;
    const { t } = this.props;
    return (
      <section className="section">
        <div className="columns is-centered">
          <div className="column is-4-desktop is-8-tablet">
            <div className="box is-radiusless is-borderless is-relative">
              <div className="has-padding-large is-paddingless-mobile">
                {/* CONFIRMATION */}
                {!deleteRequestSent
              && (
              <form data-testid="accountDeletionForm" onSubmit={(e) => { e.preventDefault(); this.deleteAccount(); }}>
                <h1 className="title is-3 is-uppercase is-spaced">{t('DELETE_ACCOUNT_TITLE')}</h1>
                <p className="subtitle is-5">{t('DELETE_ACCOUNT_P1')}</p>
                <p className="subtitle is-5">{t('DELETE_ACCOUNT_P2')}</p>
                <p className="subtitle is-5">{t('DELETE_ACCOUNT_P3')}</p>
                <p className="subtitle is-5"><strong>{t('DELETE_ACCOUNT_P4')}</strong></p>
                {deleteRequestError && <ErrorMessage testId="accountDeletionServerError" text={t('ERROR_OCCURED_PLEASE_TRY_LATER')} />}
                <button className="button is-primary is-medium is-fullwidth is-uppercase" type="submit">{t('DELETE_ACCOUNT_ACTION')}</button>
              </form>
              )}
                {/* DELETE REQUESTED */}
                {deleteRequestSent
              && (
              <div data-testid="accountDeletionRequested" className="">
                <h1 className="title is-3 is-uppercase is-spaced">{t('DELETE_ACCOUNT_TITLE')}</h1>
                <p className="subtitle is-5">{t('DELETE_ACCOUNT_REQUESTED')}</p>
              </div>
              )}
                {loading && <Loading />}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default translate()(AccountDeletionPage);
